export default "__VITE_ASSET__D2TLNTd1__"